import apiSlice from "../../app/api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getIntegrationStatus: builder.query({
			query: () => `/api/integrations/status`,
			providesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		getTransOAuth: builder.query({
			query: () => `/api/trans_oauth_redirect`,
		}),
		updateTelerouteIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/integrations/teleroute`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		updateTimocomIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/integrations/timocom`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		updateTransIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/integrations/trans`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		addMailingIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/integrations/mailing`,
				method: "POST",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "MailingIntegration", id: "LIST" }],
		}),
		checkMailingIntegration: builder.mutation({
			query: ({ testEmailTo }) => ({
				url: `/api/integrations/sendTestEmail`,
				method: "POST",
				body: { testEmailTo },
			}),
		}),
		// super-admin
		adminUpdateTelerouteIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/admin/integrations/teleroute`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		adminUpdateTimocomIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/admin/integrations/timocom`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		adminUpdateTransIntegration: builder.mutation({
			query: (data) => ({
				url: `/api/admin/integrations/trans`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		adminGetIntegrationStatus: builder.query({
			query: ({ companyId }) => `/api/admin/integrations/status/${companyId}`,
			providesTags: [{ type: "Integrations", id: "LIST" }],
		}),
		// MS OAuth
		getMicrosoftOAuth: builder.query({
			query: ({ type }) => `/api/integrations/microsoft?type=${type}`,
			providesTags: [{ type: "MicrosoftOauth", id: "LIST" }],
		}),
		disconnectMicrosoftOauth: builder.mutation({
			query: () => ({
				url: `/api/integrations/microsoft/disconnect`,
				method: "POST",
			}),
			invalidatesTags: [
				{ type: "Integrations", id: "LIST" },
				{ type: "Users", id: "LIST" },
			],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetIntegrationStatusQuery,
	useGetTransOAuthQuery,
	useUpdateTelerouteIntegrationMutation,
	useUpdateTimocomIntegrationMutation,
	useUpdateTransIntegrationMutation,
	useAddMailingIntegrationMutation,
	useCheckMailingIntegrationMutation,
	useAdminUpdateTelerouteIntegrationMutation,
	useAdminUpdateTimocomIntegrationMutation,
	useAdminUpdateTransIntegrationMutation,
	useAdminGetIntegrationStatusQuery,
	useGetMicrosoftOAuthQuery,
	useDisconnectMicrosoftOauthMutation,
} = userApiSlice;
